module.exports = __webpack_public_path__ + "24987bb64f8f5419d944a80972b18b3f.png";